import { React, useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import {
  createNewblogCat,
  getABlogCat,
  resetState,
  updateABlogCat,
} from "../features/bcategory/bcategorySlice";
let schema = yup.object().shape({
  title: yup.string().required("Category Name is Required"),
});
const Addblogcat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getBlogCatId = location.pathname.split("/")[3];
  const newBlogCategory = useSelector((state) => state.bCategory);
  const {
    isSuccess,
    isError,
    isLoading,
    createBlogCategory,
    blogCatName,
    updatedBlogCategory,
  } = newBlogCategory;
  useEffect(() => {
    if (getBlogCatId !== undefined) {
      dispatch(getABlogCat(getBlogCatId));
    } else {
      dispatch(resetState());
    }
  }, [getBlogCatId]);
  useEffect(() => {
    if (isSuccess && createBlogCategory) {
      toast.success("Blog Category Added Successfullly!");
    }
    if (isSuccess && updatedBlogCategory) {
      toast.success("Blog Category Updated Successfullly!");
      navigate("/admin/blog-category-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  
  

    const adminToken = localStorage.getItem("adminToken");
console.log("Admin Token:", adminToken);

 useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) {
      navigate("/");
    }
  }, [navigate]);
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      description: ""
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (values !== undefined) {
        try {
          console.log(values)
            axios.post(`${base_url}/api/blogs/createBlogCategory`, values).then(req=>{
              toast.success("Product Added Successfully!");
            }).catch(err=>{
              toast.error("Something Went Wrong!");
            })
        } catch (error) {
            throw error; // This error needs to be serializable.
        }
     
      } else {
        dispatch(createNewblogCat(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });
  return (
    <div>
      <h3 className="mb-4  title">
        {getBlogCatId !== undefined ? "Edit" : "Add"} Blog Category
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="title"
            onChng={formik.handleChange("title")}
            onBlr={formik.handleBlur("title")}
            val={formik.values.title}
            label="Enter Blog Category"
            id="blogcat"
          /><br></br>
            {/* Product Description */}
        <ReactQuill
          theme="snow"
          value={formik.values.description}
          onChange={(content) => formik.setFieldValue("description", content)}
        />

          <div className="error">
            {formik.touched.title && formik.errors.title}
          </div>
          <button
  className="btn btn-success border-0 rounded-3 my-5"
  type="submit"
  disabled={!(formik.isValid && formik.dirty)}
>
  {getBlogCatId !== undefined ? "Edit" : "Add"} Blog Category
</button>

        </form>
      </div>
    </div>
  );
};

export default Addblogcat;
